import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="kis-approach-to-a-transdisciplinary-programme-of-inquiry">
    <h1>KIS APPROACH TO A TRANSDISCIPLINARY PROGRAMME OF INQUIRY</h1>
    <p>
      At Kingston we acknowledge the importance of particular subject areas: language; mathematics; social studies;
      science; arts; personal, social and physical education.
    </p>
    <p>
      The knowledge, concepts and skills that constitute each of these subject areas are documented in detailed
      frameworks—scope and sequences—that set out the overall expectations for each subject.
    </p>
    <p>
      We also recognize that educating students in a set of isolated subject areas, while necessary, is not sufficient.
      Of equal importance is the need to acquire skills in context, and to explore content that is relevant to students
      and transcends the boundaries of the traditional subjects. “To be truly educated, a student must also make
      connections across the disciplines, discover ways to integrate the separate subjects, and ultimately relate what
      they learn to life” (Boyer 1995: 82).
    </p>
    <p>
      The programme defines transdisciplinary themes that identify areas of shared human experience and have meaning for
      individuals from different cultures and ethnicities. These themes are part of the common ground that unifies the
      learning in all IB World Schools offering the PYP. They provide the opportunity to incorporate both local and
      global issues in the knowledge component of the PYP written curriculum—what we want students to know about. There
      are six transdisciplinary themes:
    </p>
    <ul className="list">
      <li>Who we are</li>
      <li>Where we are in place and time</li>
      <li>How we express ourselves</li>
      <li>How the world works</li>
      <li>How we organize ourselves</li>
      <li>Sharing the planet</li>
    </ul>
    <p>
      Students inquire into and learn about local and global issues in the context of units of inquiry, each of which
      addresses a particular transdisciplinary theme. The students make connections and contributions, and deepen their
      understanding through the perspective of their personal and cultural experiences.
    </p>
    <p>
      <em>This description makes use of language from the IB Document ‘A Basis for Practice’ (2009)</em>
    </p>
  </ContentLayout>
);
